import { refsStore, eventsStore } from '../managers/globalState';
import { EVENT_CATEGORIES } from '../config/constants';
//import momenti from "moment-hijri";
import moment from 'moment-timezone';

const updateYear = newYearIndex => {
	eventsStore.setGlobalState({ yearIndex: newYearIndex });
};

const updateCategory = category => {
	eventsStore.setGlobalState({ categoryIndex: category });
};

/**
 * Loops through all the events and creates an array of all years spanning them.
 * @param {Array} allEvents
 * @returns {Array} of {Array}
 */
const getAllYears = allEvents => {
	let allYears = [['all','كل السنوات']];

	allEvents.map(event => {
		const currYear = event.date.substring(0, 4);
		let all = allYears.filter(v => {
			return v[0] == currYear
		})
		if(all.length == 0){
			const display = moment(event.date).format('YYYY');
			allYears.push([currYear,display]);
		}
	});

	return allYears.sort((a, b) => b - a);
};

const filterEvents = (allEvents, categoryIndex) => allEvents.filter(event => {
	if (!event || !event.imagecategory) { return false; }

	const category = EVENT_CATEGORIES[categoryIndex];
	const categoryFilter = category[0] === 'All Types' || (event.imagecategory?.includes(category[0].replace(/ /g, '').toLocaleLowerCase()));
	return categoryFilter;
});

export {
	updateYear,
	updateCategory,
	getAllYears,
	filterEvents
};
